import {
  SET_FEATURES_DONE,
  GET_FEATURES_DONE,
  SET_FOOTER_TEXT,
} from '../actions';
import { getIntegersParsedObject } from 'h-commons';
function features(state = {}, action) {
  switch (action.type) {
    case GET_FEATURES_DONE:
    case SET_FEATURES_DONE: {
      return { ...state, ...getIntegersParsedObject(action.payload) };
    }
    case `${SET_FOOTER_TEXT}_SUCCESS`: {
      return { ...state, 'email-footer': {...state['email-footer'], footer_text: action.payload.footer_text} };
    }
    case 'SET_OOO_SETTINGS':{
      return { ...state, 'out_of_office':  action.payload };
    }
    default: {
      return state;
    }
  }
}

export default features;